export class Page {
    constructor(container) {
        this.container = container;
        this._formContainer = this.container.querySelector(".todo-form-container");
        this._todoContainer = this.container.querySelector(".todos__list");
    }
    set todoContainer(items) {
        this._todoContainer.replaceChildren(...items);
    }
    set formContainer(formElement) {
        if (formElement) {
            this._formContainer.replaceChildren(formElement);
        }
        else {
            this._formContainer.innerHTML = "";
        }
    }
}
